// Core domain model types for mITyGarden
export const WIZARD_TOTAL_STEPS = 5;
//# sourceMappingURL=types.js.map